'use client';
import React from 'react';
import { useModel } from '@/context/ModelContext';
import { fmtCrShort } from '@/lib/financial-model';
import InputRow from './InputRow';

export default function RevenueSection() {
  const { assumptions, updateAssumption, model } = useModel();

  return (
    <div>
      <InputRow
        label="Selling Price (Ex-Factory)"
        unit="₹ / tonne"
        note="Market rate for biomass pellets in Western UP — NTPC/TPP offtake 2026"
        confidence="High"
        value={assumptions?.sellingPrice}
        onChange={(v) => updateAssumption('sellingPrice', v)}
        min={4000}
        max={15000}
        step={100}
      />
      <InputRow
        label="Annual Price Escalation"
        unit="% per year"
        note="Applied from Year 2 onwards — CPI-linked assumption"
        confidence="Medium"
        value={assumptions?.priceEscalation}
        onChange={(v) => updateAssumption('priceEscalation', v)}
        min={0}
        max={15}
        step={0.5}
        isPercent
      />
      <InputRow
        label="Carbon Credits (Base Case)"
        unit="₹ / year"
        note="Excluded from Base Case — treated as Upside only (potential ₹3–5 Cr/year at scale)"
        confidence="High"
        value={assumptions?.carbonCreditsBase}
        onChange={(v) => updateAssumption('carbonCreditsBase', v)}
        min={0}
        max={50000000}
        step={1000000}
      />
      <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-3">
        {[1, 2, 5, 10]?.map((yr) => (
          <div key={`rev-yr-${yr}`} className="p-2.5 bg-muted/50 rounded-lg">
            <p className="text-xs text-muted-foreground">Year {yr} Revenue</p>
            <p className="font-mono text-sm font-bold text-foreground">
              {fmtCrShort(model?.years?.[yr]?.revenue ?? 0)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
